import PropTypes from "prop-types";
import React, { useState } from "react";
import InputBase from "@mui/material/InputBase";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { FormHelperText, InputAdornment } from "@mui/material";
import { styled } from "@mui/system";
import { Search } from "@mui/icons-material";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  width: "100%",
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "&.Mui-error .MuiInputBase-input": {
    border: "1px solid",
    borderColor: "red",
  },
  "& .MuiInputBase-input": {
    borderRadius: "80px",
    border: "1px solid #142C5C",
    height: "40px", // Increased height to fit the icon properly
    width: "100%",
    fontSize: "16px",
    fontWeight: 400,
    color: "#365462",
    padding: "9px 14px",
    backgroundColor: "transparent",
    position: "relative", // To position end adornment inside
  },
  "& .MuiInputAdornment-root": {
    position: "absolute",
    right: "15px", // Position inside the input box
    top: "50%",
    transform: "translateY(-50%)",
  },
}));

const getEndAdornment = (type, showPassword, togglePasswordVisibility) => {
  if (type === "password") {
    return (
      <InputAdornment position="end">
        {showPassword ? (
          <VisibilityOffOutlinedIcon
            fontSize="small"
            sx={{
              cursor: "pointer",
              color: "#365462",
              opacity: "0.4",
            }}
            onClick={togglePasswordVisibility}
          />
        ) : (
          <VisibilityOutlinedIcon
            fontSize="small"
            sx={{
              cursor: "pointer",
              color: "#365462",
              opacity: "0.4",
            }}
            onClick={togglePasswordVisibility}
          />
        )}
      </InputAdornment>
    );
  } else return null;
};

function CustomTextField({
  name,
  variant,
  type,
  onChange,
  value,
  placeholder,
  errorMessage,
  className,
  onMouseLeave,
  disabled = false,
  ...props
}) {
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  return (
    <>
      <BootstrapInput
        variant={variant}
        id={name}
        name={name}
        onMouseLeave={onMouseLeave}
        type={type === "password" && !showPassword ? "password" : "text"}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        className={className}
        error={Boolean(errorMessage)}
        $isPassword={type === "password"}
        inputProps={type === "password" ? { maxLength: 100 } : {}}
        autoComplete="off"
        {...props}
        startAdornment={
          type === "search" ? (
            <InputAdornment
              position="start"
              sx={{
                cursor: "pointer",
                color: "#0832DE",
              }}
            >
              <Search fill="#0832DE" />
            </InputAdornment>
          ) : null
        }
        // endAdornment={getEndAdornment(
        //   type,
        //   showPassword,
        //   togglePasswordVisibility
        // )}
      />
      {errorMessage && (
        <FormHelperText
          sx={{ color: "error.main", fontSize: "11px", fontWeight: 400 }}
        >
          {errorMessage}
        </FormHelperText>
      )}
    </>
  );
}

export default CustomTextField;

CustomTextField.propTypes = {
  variant: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};
